module.exports = __webpack_public_path__ + "static/img/xl22.52478a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xl22.png
// module id = /LUA
// module chunks = 73